import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Account } from 'src/app/models/account.model';
import { Deposit } from 'src/app/models/deposit.model';
import { Loan } from 'src/app/models/loan.model';
import { Saving } from 'src/app/models/saving.model';
import * as fromDashboard from '../../reducers/dashboard/dashboard.reducer';
import { Card } from './../../../models/card.model';

export const selectDashboardStateFeature = createFeatureSelector<
  fromDashboard.State
>(fromDashboard.dashboardFeatureKey);

export interface HomeViewModel {
  accounts: Account[] | null;
  savings?: Saving[] | null;
  gradualSavings?: Saving[] | null;
  deposits?: Deposit[] | null;
  loans?: Loan[] | null;
  cards?: Card[] | null;
  unreadMessageCount: number | null;
}
export interface ExchangeModel {
  exchangeRateListLink: String | null;
}

export const selectHomeViewModel = createSelector(
  selectDashboardStateFeature,
  (state: fromDashboard.State): HomeViewModel => {
    let savingsArray:any = [];
    state.dashboard?.savings?.forEach((saving) => {
      savingsArray.push(saving);
    });
    state.dashboard?.gradualSavings?.forEach((saving) => {
      savingsArray.push(saving);
    });
    return {
      accounts: state.dashboard ? state.dashboard.accounts : null,
      savings: state.dashboard ? savingsArray : null,
      deposits: state.dashboard ? state.dashboard.deposits : null,
      loans: state.dashboard ? state.dashboard.loans : null,
      cards: state.dashboard ? state.dashboard.cards : null,
      unreadMessageCount: state.dashboard
        ? state.dashboard.unreadMessageCount
        : null
    };
  }
);
export const selectExchangeModel = createSelector(
  selectDashboardStateFeature,
  (state: fromDashboard.State): ExchangeModel => {
    return {
      exchangeRateListLink: state.dashboard
        ? state.dashboard.exchangeRateListLink
        : null
    };
  }
);
